import { render } from "./AttendanceRequests.vue?vue&type=template&id=1a8e040f"
import script from "./AttendanceRequests.vue?vue&type=script&lang=js"
export * from "./AttendanceRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__